import React from 'react';
import { css } from '@emotion/react';
import { AiProfileInfo } from '@/customTypes/chapter';

const sliderContainerStyle = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 0.5rem;
  backdrop-filter: blur(8px);
`;

const slideInfoStyle = css`
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  padding: 24px 24px 28px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const titleStyle = css`
  color: #fff;
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
`;

const subtitleStyle = css`
  color: rgba(255, 255, 255, 0.75);
  text-align: center;
  font-size: 14px;
`;

const indicatorsStyle = css`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const indicatorStyle = (active: boolean) => css`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${active ? 'white' : 'rgba(255, 255, 255, 0.5)'};
  margin: 0 5px;
`;

interface StoryGamePreviewCharacterNameProps {
  onPrevious?: () => void;
  onNext?: () => void;
  firstName: string;
  onChangeAiProfile: (profile: AiProfileInfo) => void;
  lastName: string;
  characterImage?: string | File;
  onProfileEdit: () => void;
  displayName: string;
  isDefault: boolean;
  dotCount: number;
  currentDotIndex: number;
}

const MobileStoryGamePreviewCharacterName: React.FC<
  StoryGamePreviewCharacterNameProps
> = ({
  onPrevious,
  onNext,
  firstName,
  lastName,
  onProfileEdit,
  isDefault,
  displayName,
  dotCount,
  currentDotIndex,
}) => {
  const dotArray = new Array(dotCount).fill(0);
  return (
    <div css={sliderContainerStyle}>
      <div css={slideInfoStyle}>
        <h2 css={titleStyle}>{lastName + '' + firstName}</h2>
        <p css={subtitleStyle}>{displayName}</p>
        <div css={indicatorsStyle}>
          {dotArray.map((_, index) => (
            <div key={index} css={indicatorStyle(index === currentDotIndex)} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MobileStoryGamePreviewCharacterName;
